module.exports = __webpack_public_path__ + "static/media/internal_env_2_hero.8ffa91c0.webp";